import ninegrid from "../index.js";

class NxLayout extends HTMLElement {

	#originalChildren;

	constructor() {
		super();
	}

	connectedCallback() {
		this.#originalChildren = Array.from(this.children).filter(child => child.tagName.toLowerCase() !== 'nx-splitter');
		this.#render();
	}

	attributeChangedCallback(name, oldValue, newValue) {
		if (this.#originalChildren && oldValue !== newValue) {
			this.#render();
		}
	}

	static get observedAttributes() {
		return ['columns'];
	}

	#render() {
		const children = this.#originalChildren;
		if (!children || children.length === 0) return;

		// 기존 자식 노드를 모두 제거하여 초기화
		while (this.firstChild) {
			this.removeChild(this.firstChild);
		}

		const columnsLayout = (this.getAttribute('columns') || '1').split(',').map(Number);
		const numRows = columnsLayout.length;

		// 메인 컨테이너를 Flexbox로 설정
		//*this.style.display = 'flex';
		//*this.style.flexDirection = 'column'; // 'flex-direction' 대신 CamelCase 사용
		//*this.style.width = '100%';
		//*this.style.height = '100%';
		//this.style.overflow = 'hidden'; // 부모 요소에 스크롤 방지

		let childIndex = 0;
		const flexBasis = 100 / numRows; // 각 행의 기본 높이 비율

		for (let row = 0; row < numRows; row++) {
			const numColumns = columnsLayout[row];

			// 행 래퍼 생성
			const rowWrapper = document.createElement('div');
			rowWrapper.classList.add('row');
			//*rowWrapper.style.display = 'flex';
			//*rowWrapper.style.flex = "1 1 0";//`1 1 ${flexBasis}%`; // 모든 행이 균등한 높이를 갖도록 설정
			//*rowWrapper.style.width = '100%';
			//rowWrapper.style.minWidth = '0';
			//rowWrapper.style.minHeight = '0';
			//rowWrapper.style.gap = '8px'; // Flexbox 간격 설정

			for (let col = 0; col < numColumns; col++) {
				if (children[childIndex]) {
					const panel = children[childIndex];
					//*panel.style.flex = '1 1 0'; // Flexbox 환경에 맞게 flex 속성 추가
					rowWrapper.appendChild(panel);
					childIndex++;
				}
				if (col < numColumns - 1) {
					const splitter = document.createElement('nx-splitter');
					//splitter.classList.add("h");
					rowWrapper.appendChild(splitter);
				}
			}

			this.appendChild(rowWrapper);

			if (row < numRows - 1) {
				const splitter = document.createElement('nx-splitter');
				splitter.classList.add("v");
				this.appendChild(splitter);
			}
		}
	}
}

if (!customElements.get('nx-layout')) {
	customElements.define('nx-layout', NxLayout);
}